import React, { useState, useEffect } from 'react';
import { AiOutlineDownload, AiOutlineStar } from 'react-icons/ai';
import Card from 'react-bootstrap/Card';
import Loading from "../../components/Loading";
import {RiArchiveFill, RiArchiveLine} from 'react-icons/ri';
import {FaFilePdf} from 'react-icons/fa';
import Paper from '@mui/material/Paper';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Button, CardActions, useTheme, IconButton } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import api from '../../services/api';
import icon from '../../image/coletaIconGreen.svg'
import LoadingButton from '@mui/lab/LoadingButton';
import dayjs from 'dayjs'
import { PDFDocument } from 'pdf-lib'

import ImageIcon from '@mui/icons-material/Image';
import BorderColorIcon from '@mui/icons-material/BorderColor';

import ImageViewer from 'react-simple-image-viewer';
import { getToken } from '../../services/auth';
import HeaderBody from '../../components/HeaderBody';
import Steps from './Steps';
import Rating from '@mui/material/Rating';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import AvaliarColeta from './AvaliarColeta';
import { buscarAvaliacoes, enviarAvaliacao } from '../../services/avaliacoesService';

// Mesmo par Snackbar+Alert que as outras paginas do portal usam.
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Coletas({setShowColetas, user}) {
    const theme = useTheme();
    let initialized = false
    let idContrato = user.idContrato;
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    // Estado de avaliacao por OS, indexado por id: { nota, podeAvaliar, motivo }
    const [avaliacoes, setAvaliacoes] = useState({});
    const [avaliando, setAvaliando] = useState(null);
    const [alerta, setAlerta] = useState({ type: 'success', msg: '', show: false });
    const [ page, setPage ] = useState(1);
    const [loadingBt, setLoadingBt] = useState(false);
    const [inicio, setInicio] = useState('2024-04-17');
    const [fim, setFim] = useState(new Date());
    useEffect(() => {
        setPage(1);
        const currentDate = dayjs();
        const formattedDate = currentDate.format('YYYY-MM-DD');
        setFim(formattedDate)
        setInicio(formattedDate)
        
        const getOrders = async (contrato) => {
            setLoading(true)
            let token = await getToken();
            api.get(`/clients/orders`,{
                params: {
                    token,
                    page: 0,
                    contrato,
                    limit: 30,
                }
            }).then(function (response) {
                let {data, status} = response.data;
                if(status === true){
                    if(data != null){
                        setList(data)
                    }else{
                        setList([])
                    }
                }
                setLoading(false)
                 // eslint-disable-next-line react-hooks/exhaustive-deps
                initialized = false;
            }).catch(function(error){
                console.log(error)
                setLoading(false)
                initialized = false;
            });
        }
        if(idContrato !== 0 && idContrato != null && idContrato !== undefined){
            if (!initialized) {
                initialized = true;
                getOrders(idContrato);
            }
        }
    }, [idContrato]);
    /**
     * Estado das avaliacoes das coletas atualmente na lista.
     *
     * Roda a cada mudanca de `list` de proposito: o "Mostrar mais" acrescenta
     * itens, e so buscar na primeira pagina deixaria os novos cards sem estado.
     */
    useEffect(() => {
        const ids = list.map(item => item.id).filter(Boolean);
        if (ids.length === 0) return;

        let ativo = true;
        buscarAvaliacoes(ids)
            .then(estados => {
                if (!ativo) return;
                setAvaliacoes(anterior => {
                    const mapa = { ...anterior };
                    estados.forEach(estado => { mapa[estado.ordemId] = estado; });
                    return mapa;
                });
            })
            .catch(() => {
                // A lista de coletas continua de pe: so a avaliacao fica
                // indisponivel. O detalhe tecnico ja foi para cliente_app_log
                // dentro do servico; aqui o cliente so precisa saber que o
                // botao "Avaliar" nao aparece por falha nossa, e nao porque a
                // coleta dele nao pode ser avaliada.
                if (!ativo) return;
                setAlerta({
                    type: 'warning',
                    msg: 'Nao foi possivel carregar as avaliacoes. Tente novamente mais tarde.',
                    show: true,
                });
            });

        return () => { ativo = false; };
    }, [list]);

    const abrirAvaliacao = (coleta) => setAvaliando(coleta);

    const confirmarAvaliacao = async ({ nota, comentario }) => {
        try {
            await enviarAvaliacao(avaliando.id, { nota, comentario });
            setAvaliacoes(anterior => ({
                ...anterior,
                [avaliando.id]: {
                    ...(anterior[avaliando.id] || {}),
                    ordemId: avaliando.id,
                    nota,
                    comentario,
                    podeAvaliar: false,
                    motivo: 'ja_avaliada',
                },
            }));
            setAvaliando(null);
            setAlerta({ type: 'success', msg: 'Avaliacao enviada. Obrigado!', show: true });
        } catch (erro) {
            const msg = erro?.response?.data?.message || 'Nao foi possivel enviar sua avaliacao.';
            setAlerta({ type: 'error', msg, show: true });
        }
    };

    const loadMore = async (contrato) => {
        setLoadingBt(true)
        let token = await getToken();
        api.get(`/clients/orders`,{
            params: {
                token,
                page: page,
                contrato,
                limit: 30,
            }
        }).then(function (response) {
            let {data, status} = response.data;
            if(status === true){
                if(data != null){
                    setList(oldList => [...oldList, ...data]);
                }
            }
            setLoadingBt(false)
            setPage(page + 1);
        }).catch(function(error){
            console.log(error)
            setLoadingBt(false)
        });
    }
    const open = (url) => {
        window.open(url, '_blank', 'noreferrer');
    }
    const openManifesto = async (url) => {
        setLoading(true);
        const pngUrl = 'https://greenium.com.br/api/public/assinaturas/assi_dudu.png'
        const pngImageBytes = await fetch(pngUrl).then((res) => res.arrayBuffer())
        const donorPdfBytes = await fetch(url).then(res => res.arrayBuffer());
        const donorPdfDoc = await PDFDocument.load(donorPdfBytes);
        const page = donorPdfDoc.getPage(0);
        const pngImage = await donorPdfDoc.embedPng(pngImageBytes)
        const pngDims = pngImage.scale(0.05)
        page.drawImage(pngImage, {
            x: (page.getWidth() / 2) + 160,
            y: (page.getHeight() / 2) + 120,
            width: pngDims.width,
            height: pngDims.height,
        })
        const pdfDataUri = await donorPdfDoc.saveAsBase64({ dataUri: true });
        let byteString = atob(pdfDataUri.split(',')[1]);
		let mimeString = pdfDataUri.split(',')[0].split(':')[1].split(';')[0]
		let ab = new ArrayBuffer(byteString.length);
		let ia = new Uint8Array(ab);
		// set the bytes of the buffer to the correct values
		for (let i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		let blob = new Blob([ab], {type: mimeString});
        setLoading(false);
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank', 'noreferrer');
    }
    const [height, setWidth] = useState(0);
    useEffect(() => {
        const element = document.getElementById('home');
        if (element) {
          setWidth(element.getBoundingClientRect().height - 300); // or height
        }
    }, []);
    const [isViewerOpen, setIsViewerOpen] = useState(0);
    const closeImageViewer = () => {
        setIsViewerOpen(0);
    };
    const [isViewerOpen2, setIsViewerOpen2] = useState(0);
    const closeImageViewer2 = () => {
        setIsViewerOpen2(0);
    };
    const ordensPdf = () => {
        setLoading(true);
         api.get(`/contratoeditar/ordens`, {
            params: {
                inicio,
                fim,
                contrato: idContrato,
                tipo: 0,
            }
        }).then(function(response) {
            setLoading(false);
            let data = response.data
            const ids = [];
            data.forEach(ordens => {
                ids.push(ordens.id)
            });
            window.open('https://greenium.com.br/cliente/painel2.php?execute=suporte/ordem/ordem-servico-todas&ordemImprimirTT=' + ids.join(','), '_blank').focus();
           
        }).catch(function(error) {
            setLoading(false);
            console.log(error);
            console.log(error?.response?.data);
        });
    }
    const handleChangeInicio = event => {
        setInicio(event.target.value)
    }
    const handleChangeFim = event => {
        setFim(event.target.value)
      }
    const renderFaturas = (element, idx) => {
        let {id, data, status, coleta, quantidade, foto, assi, ordem, romaneio, manifesto, hoje} = element;
        return (
            <div key={idx} className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" style={{marginBottom: 20, marginTop: 20}}>
                <Paper elevation={12}>
                    <CardContent>
                        <Stack direction="row" spacing={2}>
                            {hoje ? (
                                <Steps 
                                id={id} 
                                idContrato={idContrato}
                                status={status} 
                                data={data} />
                            ) : (
                                <Stack direction="row" spacing={2}>
                                    {status === "Ordem Realizada" ? (
                                        <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 50, height: 50 }} >
                                            <RiArchiveFill color={"var(--main-white-color)"} size={30} />
                                        </Avatar>
                                    ) : (
                                        <Avatar sx={{ backgroundColor: 'var(--main-secondy)', width: 50, height: 50 }} >
                                            <RiArchiveLine color={"var(--main-white-color)"} size={30} />
                                        </Avatar>
                                    )}
                                    <Stack direction="column" spacing={0}>
                                        <Typography gutterBottom variant="body2" component="div">
                                            {id} - {data}
                                        </Typography>
                                        <Typography gutterBottom variant="body2" component="div">
                                            Status: {status}
                                        </Typography>
                                    </Stack>
                                </Stack>
                            )}
                        </Stack>
                        <Typography variant="body2">
                            {coleta}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" style={{marginTop: 5}}>
                            Quantidade: {quantidade}
                        </Typography>
                    </CardContent>
                    <CardActions style={{justifyContent: 'space-around', paddingBottom: 16}}>
                        {foto == null ? (
                            <Button 
                                variant="contained" 
                                style={{backgroundColor: '#a3a3a3', borderRadius: 25}} 
                                size="small" 
                                startIcon={<ImageIcon />}
                                disabled={true} 
                                >
                                Foto
                            </Button>
                            
                        ) : (
                            foto.length > 0 && (
                                <Button 
                                    variant="contained" 
                                    style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                                    size="small" 
                                    startIcon={<ImageIcon />}
                                    onClick={() => setIsViewerOpen(id)}
                                    >
                                    {foto.length > 1 ?  "Fotos" : "Foto"}
                                </Button>
                            )
                        )}
                        {assi == null ? (
                             <Button 
                                variant="contained" 
                                style={{backgroundColor: '#a3a3a3', borderRadius: 25}} 
                                size="small" 
                                startIcon={<BorderColorIcon />}
                                disabled={true} 
                                >
                                Assinatura
                            </Button>
                        ) : (
                             <Button 
                             variant="contained" 
                             style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                             size="small" 
                             startIcon={<BorderColorIcon />}
                             disabled={assi == null ? true : false} 
                             onClick={() => setIsViewerOpen2(id)}
                             >
                             Assinatura
                         </Button>
                        )}
                        {romaneio && (
                            <Button 
                                variant="contained" 
                                style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                                size="small" 
                                startIcon={<AiOutlineDownload />}
                                disabled={romaneio == null ? true : false} 
                                onClick={() => open(romaneio)}
                                >
                                Romaneio
                            </Button>
                        )}
                        {manifesto && (
                            <Button 
                                variant="contained" 
                                style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                                size="small" 
                                startIcon={<AiOutlineDownload />}
                                disabled={manifesto == null ? true : false} 
                                onClick={() => openManifesto(manifesto)}
                                >
                                Manifesto
                            </Button>
                        )}
                        {ordem == null ? (
                             <Button 
                                variant="contained" 
                                style={{backgroundColor: '#a3a3a3', borderRadius: 25}} 
                                size="small" 
                                startIcon={<AiOutlineDownload />}
                                disabled={true} 
                                onClick={() => open(ordem)}
                                >
                                Ordem
                            </Button>
                        ) : (
                            <Button 
                                variant="contained" 
                                style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                                size="small" 
                                startIcon={<AiOutlineDownload />}
                                disabled={ordem == null ? true : false} 
                                onClick={() => open(ordem)}
                                >
                                Ordem
                            </Button>
                        )}
                        {/*
                            Avaliacao da coleta. O estado (nota, prazo, se pode
                            avaliar) vem do backend — a tela so respeita.
                        */}
                        {avaliacoes[id] && avaliacoes[id].nota != null ? (
                            <Rating
                                value={avaliacoes[id].nota}
                                readOnly
                                size="small"
                                getLabelText={v => `${v} ${v === 1 ? 'estrela' : 'estrelas'}`}
                            />
                        ) : avaliacoes[id] && avaliacoes[id].podeAvaliar ? (
                            <Button
                                variant="contained"
                                style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}}
                                size="small"
                                startIcon={<AiOutlineStar />}
                                onClick={() => abrirAvaliacao({ id, data })}
                                >
                                Avaliar
                            </Button>
                        ) : null}
                        {isViewerOpen === id && (
                            <ImageViewer
                            src={foto}
                            style={{marginTop: 50}}
                            currentIndex={0}
                            disableScroll={ true }
                            closeOnClickOutside={ true }
                            onClose={ closeImageViewer }
                            backgroundStyle={{backgroundColor: "#00000090"}}
                            />
                        )}
                        {isViewerOpen2 === id && (
                            <ImageViewer
                            src={[assi]}
                            currentIndex={0}
                            disableScroll={ true }
                            closeOnClickOutside={ true }
                            onClose={ closeImageViewer2 }
                            backgroundStyle={{backgroundColor: "#00000090"}}
                            />
                        )}
                    </CardActions>
                </Paper>
            </div>
        );
    }
    return (
        <>
            <div style={{margin: 20, display: 'flex', alignItems: 'center', gap: 20}} >
                Exportar:
                <input type="date" value={inicio} onChange={handleChangeInicio} style={{width: 200}} className="form-control input-sm" />
                <input type="date" value={fim} onChange={handleChangeFim} style={{width: 200}} className="form-control input-sm" />
                <IconButton 
                    variant="contained" 
                    style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 5, boxShadow: "0px 3px 5px -1px"}}
                    onClick={ordensPdf}
                    >
                    <FaFilePdf color={"var(--main-white-color)"} />
                </IconButton>
            </div>
            <Card style={{margin: 20}} className={theme.palette.mode === "dark" ? "bg-dark text-white" : null}>
                <Loading open={loading} />
                <Card.Header>
                    <HeaderBody title={"Coletas"} icon={icon} setShow={setShowColetas} />
                </Card.Header>
                <Card.Body className='row' style={{paddingTop: 0, paddingBottom: 0}}>
                    <div style={{overflow: "auto", height: height}}>
                        {list.map((elemeto, index) => (
                            renderFaturas(elemeto, index)
                        ))}
                        {list.length > 0 && (
                            <div className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" >
                                <CardActions style={{justifyContent: 'space-around'}}>
                                    <LoadingButton 
                                    variant="secondary" 
                                    loading={loadingBt} 
                                    onClick={() => loadMore(idContrato)}
                                    >
                                        Mostrar mais...
                                    </LoadingButton>
                                </CardActions>
                            </div>
                        )}
                    </div>
                </Card.Body>
            </Card>

            {avaliando && (
                <AvaliarColeta
                    mostrar={!!avaliando}
                    handleClose={() => setAvaliando(null)}
                    coleta={avaliando}
                    estado={avaliacoes[avaliando.id]}
                    onEnviar={confirmarAvaliacao}
                />
            )}

            <Snackbar
                open={alerta.show}
                autoHideDuration={6000}
                onClose={() => setAlerta(a => ({ ...a, show: false }))}
            >
                <Alert
                    onClose={() => setAlerta(a => ({ ...a, show: false }))}
                    severity={alerta.type}
                    sx={{ width: '100%' }}
                >
                    {alerta.msg}
                </Alert>
            </Snackbar>
        </>
    );
}

export default Coletas;